import { render, staticRenderFns } from "./PageLayout.vue?vue&type=template&id=02834195&"
import script from "./PageLayout.vue?vue&type=script&lang=js&"
export * from "./PageLayout.vue?vue&type=script&lang=js&"
import style0 from "./PageLayout.vue?vue&type=style&index=0&id=02834195&prod&lang=css&"
import style1 from "./PageLayout.vue?vue&type=style&index=1&id=02834195&prod&v-if=%24scopedSlots.tour&lang=scss&"
import style2 from "./PageLayout.vue?vue&type=style&index=2&id=02834195&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports